<template>
    <section id="news">
        <div class="container">
            <div class="header">
                <h2 class="title display-4" data-aos="fade-right" data-aos-offset="10">News</h2>
                <div class="categories">
                    <span class="category news-category small " data-category="1" data-aos="zoom-in-up">Lifestyle & Fashion</span>
                    <span class="category news-category small " data-category="2" data-aos="zoom-in-up">Startups & Tech</span>
                    <span class="category news-category small " data-category="3" data-aos="zoom-in-up">Education & Careers</span>
                    <span class="category news-category small " data-category="4" data-aos="zoom-in-up">People & Projects</span>
                    <span class="category news-category small " data-category="5" data-aos="zoom-in-up">Sports & Funbox</span>
                    <span class="category news-category small " data-category="6" data-aos="zoom-in-up">Dealing with the Past</span>
                </div>
            </div>

            <div class="row mt-main">
                <div class="col-lg-6 col-sm-12" data-aos="zoom-in" data-aos-offset="10">
                    <div class="news-card">
                        <div class="image">
                            <a :href="'news/'+newsLatest.id">
                                <img
                                    :src="newsLatest.file">
                                <div class="overlay"></div>
                            </a>
                            <div class="details">
                                <p class="description h4"
                                   data-aos="fade-right" data-aos-offset="10">{{newsLatest.title | truncate(120)}}</p>
                                <span class="date h6"
                                      data-aos="fade-right" data-aos-offset="10">{{newsLatest.created_at}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-sm-12 right-news" data-aos="zoom-in" data-aos-offset="10">


                    <div class="row w-100" id="newsCards" v-for="n in news">
                        <div class="col-4">
                            <div class="news-card">
                                <div class="image">
                                    <a :href="'news/'+n.id">
                                        <img
                                           :src="n.file">
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="col-8">
                            <div class="details">
                                    <span class="date"
                                          data-aos="fade-right" data-aos-offset="10">{{ n.created_at }}</span>
                                <a :href="'news/'+n.id"><p class="description h6 mt-1"
                                                             data-aos="fade-right" data-aos-offset="10">{{n.title | truncate(100)}}</p>
                                </a>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "news-latest",
    props: ['news', 'newsLatest'],
    mounted() {
    }
}
</script>

<style scoped>

</style>
